import { VersionComponent } from './version.component'
import { Routes } from '@angular/router'

export const versionRoutes: Routes = [
  {
    path: 'version',
    component: VersionComponent,
  },
]